import ReactGA from 'react-ga4';

// Custom event tracking functions
export const trackEvent = (category, action, label = null, value = null) => {
  if (process.env.REACT_APP_GA_MEASUREMENT_ID) {
    ReactGA.event({
      category,
      action,
      label,
      value
    });
  }
};

// User Authentication Events
export const trackUserRegistration = (role) => {
  trackEvent('User', 'Registration', role);
};

export const trackUserLogin = (role) => {
  trackEvent('User', 'Login', role);
};

export const trackUserLogout = () => {
  trackEvent('User', 'Logout');
};

// Worker Events
export const trackWorkerProfileView = (workerId, workerName) => {
  trackEvent('Worker', 'Profile View', `${workerId} - ${workerName}`);
};

export const trackWorkerProfileCreate = () => {
  trackEvent('Worker', 'Profile Created');
};

export const trackWorkerProfileUpdate = () => {
  trackEvent('Worker', 'Profile Updated');
};

// Search Events
export const trackSearch = (searchQuery, category = null) => {
  trackEvent('Search', 'Query', searchQuery);
  if (category) {
    trackEvent('Search', 'Category Filter', category);
  }
};

export const trackAdvancedSearch = (filters) => {
  trackEvent('Search', 'Advanced Search', JSON.stringify(filters));
};

// Job Booking Events
export const trackJobBookingStart = (workerId) => {
  trackEvent('Booking', 'Started', workerId);
};

export const trackJobBookingComplete = (workerId, amount) => {
  trackEvent('Booking', 'Completed', workerId, amount);
};

// Payment Events
export const trackPaymentInitiated = (paymentType, amount) => {
  trackEvent('Payment', 'Initiated', paymentType, amount);
};

export const trackPaymentSuccess = (paymentType, amount) => {
  trackEvent('Payment', 'Success', paymentType, amount);
};

export const trackPaymentCancelled = (paymentType) => {
  trackEvent('Payment', 'Cancelled', paymentType);
};

// Review Events
export const trackReviewSubmit = (workerId, rating) => {
  trackEvent('Review', 'Submitted', workerId, rating);
};

// Verification Events
export const trackVerificationSubmit = (verificationType) => {
  trackEvent('Verification', 'Submitted', verificationType);
};

// Navigation Events
export const trackCategoryClick = (category) => {
  trackEvent('Navigation', 'Category Click', category);
};

export const trackDashboardAccess = (role) => {
  trackEvent('Navigation', 'Dashboard Access', role);
};

// Admin Events
export const trackAdminAccess = () => {
  trackEvent('Admin', 'Dashboard Access');
};

// Contact Events
export const trackContactWorker = (workerId) => {
  trackEvent('Contact', 'Worker Contact', workerId);
};
